import MyCourseActionTypes from "./myCourse.types";
import {
	setCourseState,
	setFetchAttemptSuccess,
	setFetchInstruction,
	handleInputChange,
} from "./myCourse.utils";
import { initialCourseState } from "../initialState";

export const setCourseDetails = (state = initialCourseState, action = {}) => {
	switch (action.type) {
		case MyCourseActionTypes.SET_INITIAL_COURSE_DETAILS:
			return Object.assign({}, state, { ...action.payload });
		case MyCourseActionTypes.FETCH_COURSE_DETAILS.SUCCESS:
			return Object.assign({}, state, setCourseState(action.payload, state));
		case MyCourseActionTypes.FETCH_COURSE_DETAILS.SHIMMER:
			return Object.assign({}, initialCourseState, {});
		case MyCourseActionTypes.FETCH_ATTEMPT.SUCCESS:
			return Object.assign({}, state, setFetchAttemptSuccess(action.payload));
		case MyCourseActionTypes.FETCH_INSTRUCTIONS.SUCCESS:
			return Object.assign({}, state, setFetchInstruction(action.payload));
		case MyCourseActionTypes.START_ATTEMPT.SUCCESS:
			return Object.assign({}, state, { startAttemptSuccess: true });
		case MyCourseActionTypes.SET_SPEECH_STATUS:
			return Object.assign({}, state, { isSpeechOn: action.payload });
		case MyCourseActionTypes.FETCH_TASK_DETAILS.SUCCESS:
			return Object.assign({}, state, { taskList: action.payload });
		case MyCourseActionTypes.FETCH_CALL_HISTORY.SUCCESS:
			return Object.assign({}, state, { callHistory: action.payload });
		case MyCourseActionTypes.SET_FILE_VALUE:
			return Object.assign({}, state, {
				selectedFile: action.payload.files[0],
				fileName: action.payload.files[0].name,
			});
		case MyCourseActionTypes.SET_FILE_ERROR:
			return Object.assign({}, state, { fileError: action.payload });
		case MyCourseActionTypes.SUBMIT_ASSIGNMENT.SUCCESS:
			return Object.assign({}, state, { fileSubmitStatus: true });
		case MyCourseActionTypes.SET_CANCEL_REASON:
			return Object.assign({}, state, { cancelReason: action.payload });
		case MyCourseActionTypes.RESET_COURSE_ID:
			return Object.assign({}, state, { courseId: "" });
		case MyCourseActionTypes.RESET_UNIT_ID:
			return Object.assign({}, state, { requestedUnit: -1 });
		case MyCourseActionTypes.SET_SCHEDULE_ID:
			return Object.assign({}, state, { taskScheduleId: action.payload });
		case MyCourseActionTypes.HANDLE_INPUT_CHANGE:
			return Object.assign({}, state, { ...handleInputChange(action.payload) });
		case MyCourseActionTypes.UPDATE_ACTIVE_COURSE:
			return Object.assign({}, state, { courseId: action.payload });
		case MyCourseActionTypes.GENERATE_CERTIFICATE.SUCCESS:
			return Object.assign({}, state, { certificateUrl: action.payload });
		case MyCourseActionTypes.GET_UPNEXT.SUCCESS:
			return Object.assign({}, state, {
				upnextAll: action.payload.upnext,
				show_dailystep: action.payload.show_dailystep,
			});
		case MyCourseActionTypes.SET_SHOW_TESTINSTRUCTION:
			return Object.assign({}, state, { showTestInstr: action.payload });
		case MyCourseActionTypes.SET_SHOW_GRADE:
			return Object.assign({}, state, { showGrade: action.payload });
		case MyCourseActionTypes.SET_SHOW_CANCEL_REASON:
			return Object.assign({}, state, { showCancelReason: action.payload });
		case MyCourseActionTypes.SET_SHOW_INFO:
			return Object.assign({}, state, { showInfo: action.payload });
		case MyCourseActionTypes.SET_ACTIVE_UNIT:
			return Object.assign({}, state, { activeUnit: action.payload });
		case MyCourseActionTypes.SET_PREVIEW_MODE:
			return Object.assign({}, state, { previewMode: action.payload });
		default:
			return state;
	}
};
